import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useAuth } from 'modules/auth/hooks'
import { useEventCheckout } from 'modules/events/hooks'
import { Button, Container } from 'react-bootstrap'

import './Checkout.styles.css'

export const Checkout = () => {
  const navigate = useNavigate()
  const { uuid } = useParams()
  const { user } = useAuth()
  const [searchParams] = useSearchParams()

  const { eventCheckout } = useEventCheckout(
    uuid,
    searchParams.get('product') || undefined
  )

  if (!user) return <div>Loading...</div>

  return (
    <Container fluid>
      <div className='main'>
        <h3>Checkout Completed</h3>
        <div>{eventCheckout.event.name}</div>
        <div>{eventCheckout.product.priceFormatted}</div>
        <Button onClick={() => navigate(`/events/${eventCheckout.event.uuid}`)}>
          Back to {eventCheckout.event.name}
        </Button>
      </div>
    </Container>
  )
}
